import { ReactElement } from 'react';
import { Route } from 'react-router';
import { JOB_TYPE } from '../../../modules/jobs/jobs.model';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { JobNotFoundView } from '../../views/errors/JobNotFound.view';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { TrainingDetailsCreateView, TrainingDetailsView } from '../../views/home/trainingDetails/TrainingDetails.view';
import { TrainingDetailsPredictionInspectorView } from '../../views/home/trainingDetails/TrainingDetailsPredictionInspector.view';
import { TrainingsView } from '../../views/home/Trainings.view';
import { Home } from '../config/Home';

export const TrainingsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Trainings.List.Path}>
      <TrainingsView />
    </Route>
    <Route path={Home.Trainings.NotFound.Path}>
      <JobNotFoundView jobType={JOB_TYPE.TRAINING} />
    </Route>
    <Route path={Home.Trainings.Create.Path}>
      <TrainingDetailsCreateView />
    </Route>
    <Route path={Home.Trainings.Details.PredictionInspector.Path}>
      <TrainingDetailsPredictionInspectorView />
    </Route>
    <Route path={Home.Trainings.Details.Path}>
      <TrainingDetailsView />
    </Route>
  </SwitchWithNotFound>
);
